'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = redirectable;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = require('react-router-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function redirectable() {
  return function (WrappedComponent) {
    return function (_React$Component) {
      (0, _inherits3.default)(RedirectableWrapper, _React$Component);

      function RedirectableWrapper() {
        (0, _classCallCheck3.default)(this, RedirectableWrapper);
        return (0, _possibleConstructorReturn3.default)(this, (RedirectableWrapper.__proto__ || (0, _getPrototypeOf2.default)(RedirectableWrapper)).apply(this, arguments));
      }

      (0, _createClass3.default)(RedirectableWrapper, [{
        key: 'localisePath',
        value: function localisePath(location) {
          var locale = this.props.params.lng || 'en';
          return '/' + locale + '/store' + location;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var redirect = function redirect(location) {
            return _this2.props.dispatch((0, _reactRouterRedux.push)(location));
          };
          var localisedRedirect = function localisedRedirect(location) {
            return redirect(_this2.localisePath(location));
          };

          return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({}, this.props, {
            redirect: redirect,
            localisedRedirect: localisedRedirect
          }));
        }
      }]);
      return RedirectableWrapper;
    }(_react2.default.Component);
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/redirectable.js
// module id = 81
// module chunks = 0